import { useAuth } from "@/contexts/AuthContext";
import { Link } from "react-router-dom";
import { UserNav } from './UserNav';

export const Header = () => {
  const { user } = useAuth();

  if (!user) return null;

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white border-b">
      <div className="container mx-auto px-4 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2">
          <img 
            src="/jambace-logo.svg" 
            alt="JAMBACE" 
            className="h-10 w-auto"
          />
        </Link>
        <UserNav />
      </div>
    </header>
  );
}; 